//
//

import { mapGetters, mapActions, mapMutations } from "vuex";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import AQCheckbox from "@/components/Generics/AQCheckbox/AQCheckbox.vue";
import AQDropdown from "@/components/Generics/AQDropdown/AQDropdown.vue";
import { CHECK_NAME_REGEX_STARTING_ALPHA_ONLY } from "@/assets/js/appConfig";
import shortId from "short-uuid";

export default {
    name: "AddAttributeModal",
    components: {
        AQModal, AQInput, AQDialog, AQCheckbox, AQDropdown
    },
    props: {
        diagramInstance: { type: Object, default: () => {} },
        showAddEditPropertyData: { type: Boolean, default: false },
        classUuid: { type: String, default: "" },
        temporaryClassInfo: { type: Object, default: () => {} },
        parentClassArray: { type: Array, default: () => [] },
        propertyUuid: { type: String, default: "" },
        isInEdit: { type: Boolean, default: false },
        propertyNameFromEdit: { type: String, default: "" },
        propertyTypeFromEdit: { type: String, default: "" },
        blockLabelFromEdit: { type: Boolean, default: false },
        isEmbeddedFromEdit: { type: Boolean, default: false },
        isCat: { type: Boolean, default: false },
        isIndexableFromEdit: { type: Boolean, default: false },
        isListFromEdit: { type: Boolean, default: false },
        isPersonalInformationFromEdit: { type: Boolean, default: false },
        dataFromGetResponse: { type: Object, default: () => {} },
        parentClassData: { type: Object, default: () => {} },
        classesListForModal: { type: Array, default: () => [] },
        sendBlockChainToggle: { type: Boolean, default: false },
        editAtr: { type: Boolean, default: false },
        indexAttr: { type: Number, default: 0 },
        checkObjAttr: { type: Array, default: () => [] }
    },
    data() {
        return {
            showModalFields: false,
            propertyName: "",
            propType: "",
            blockLabel: false,
            isIndexable: false,
            isList: false,
            isBlockChnProp: null,
            isIndexDis: true,
            isListDis: false,
            isEmbDis: true,
            isCatDis: false,
            noNameFound: false,
            isEmbedded: false,
            duplicatePropName: false,
            forbiddenAttrName: false,
            duplicatedPropNameLabel: "",
            optionsDataModel: [],
            openDialog: false,
            createAnother: false,
            defaultTypeAttr: "",
            resetDefaultVal: false,
            isPersonalInformation: false,
            action: null,
            fromAttr: true,
            hasChanges: false,
            showDialog: false,
            initialValue: "",
            draftMode: false,
            count: 0,
            draftValue: "",
            defaultSource: "String",
            counter: 0,
            counterName: 0
        };
    },
    computed: {
        ...mapGetters("apps", ["currentApp"]),
        ...mapGetters("main", ["interfaceDirty"]),
        actions() {
            return this.editAtr
                ? [
                    {
                        name: this.$t("generic.delete"),
                        label: this.$t("dataModel.modal.deleteBtnDlt"),
                        color: "negative"
                    }
                ]
                : null;
        },
        defaultPropType() {
            return typeof this.computedPropertyTypeFromEdit === "object" ? this.computedPropertyTypeFromEdit[0].value : this.computedPropertyTypeFromEdit;
        },
        headerActionsModel() {
            return this.editAtr ? [{ label: this.$t("diagrams.components.setRules.delete") }] : [];
        },
        checkErrorState() {
            return !(this.noNameFound || this.duplicatePropName || this.forbiddenAttrName);
        },
        checkAddBtnState() {
            let propName = "";
            let attrType = "";

            if (this.editAtr) {
                propName = this.computedPropertyNameFromEdit;
                attrType = this.computedPropertyTypeFromEdit;
            } else {
                propName = this.propertyName;
                attrType = this.propType;
            }
            return !(propName && attrType && this.checkErrorState);
        },
        getTootltipMsg() {
            let msg;
            if (
                this.temporaryClassInfo
                && this.temporaryClassInfo.uuid === this.classUuid
                && !this.temporaryClassInfo.blockchain
            ) {
                msg = `${this.$t("dataModel.modal.smartContractTooltip")}`;
            } else {
                msg = `${this.$t(
                    "dataModel.modal.smartContractTooltipActivated",
                    {
                        className:
                            this.propType || this.computedPropertyTypeFromEdit
                    }
                )}`;
            }
            return msg;
        },
        computedTitleDialog() {
            return this.action ? this.$t("dataModel.modal.closeTitleDialog") : this.$t("dataModel.modal.deletePropDialog");
        },
        computedMessageBody() {
            return this.action ? this.$t("dataModel.modal.closeBodyDialog") : this.$t("dataModel.modal.deleteBodyMsgAttr");
        },
        computedBtn() {
            return this.action ? this.$t("dataModel.modal.closeDialog") : this.$t("dataModel.modal.deleteBtnDlt");
        },

        computedPropertyNameFromEdit: {
            get() {
                return this.propertyNameFromEdit
                    ? this.propertyNameFromEdit.charAt(0).toLowerCase()
                          + this.propertyNameFromEdit.slice(1)
                    : this.propertyNameFromEdit;
            },
            set(v) {
                const updateAttr = v.charAt(0).toLowerCase() + v.slice(1);
                this.$emit("update:propertyNameFromEdit", updateAttr);
            }
        },
        computedPropertyTypeFromEdit: {
            get() {
                return this.propertyTypeFromEdit;
            },
            set(v) {
                if (!this.draftMode) {
                    this.initialValue = this.propertyTypeFromEdit;
                    this.$emit("update:propertyTypeFromEdit", v[0].value || v);
                } else {
                    this.draftValue = v;
                }
            }
        },
        computedBlockLabelFromEdit: {
            get() {
                return this.blockLabelFromEdit;
            },
            set(v) {
                this.$emit("update:blockLabelFromEdit", v);
            }
        },
        computedIsEmbeddedFromEdit: {
            get() {
                return this.isEmbeddedFromEdit;
            },
            set(v) {
                this.$emit("update:isEmbeddedFromEdit", v);
            }
        },
        computedIsIndexableFromEdit: {
            get() {
                return this.isIndexableFromEdit;
            },
            set(v) {
                this.$emit("update:isIndexableFromEdit", v);
            }
        },
        computedIsPersonalInformation: {
            get() {
                return this.isPersonalInformationFromEdit;
            },
            set(v) {
                this.$emit("update:isPersonalInformationFromEdit", v);
            }
        },
        computedIsListFromEdit: {
            get() {
                return this.isListFromEdit;
            },
            set(v) {
                this.$emit("update:isListFromEdit", v);
            }
        },

        ...mapGetters("catalogs", [
            "columnDataTypesWithAttDDL",
            "existingCatalogsAsList"
        ]),
        propertyType() {
            this.classListDdl();
            return [
                ...this.columnDataTypesWithAttDDL,
                ...this.existingCatalogsAsList,
                ...this.existDataModelClass()
            ];
        },
        titleModal() {
            return !this.editAtr
                ? this.$t("dataModel.modal.titleAddFields")
                : this.$t("dataModel.modal.titleEditFields");
        },
        modalBtnLabel() {
            return this.editAtr ? { label: this.$t("generic.done"), disabled: this.checkAddBtnState }
                : { label: this.$t("liveView.filters.addBtn"), disabled: this.checkAddBtnState };
        },
        errorLabel() {
            let errorLabel = "";
            if (this.noNameFound) {
                errorLabel = this.$t("dataModel.modal.noNameError");
            }

            if (this.forbiddenAttrName) {
                errorLabel = this.$t("dataModel.modal.forbiddenAttName");
            }

            if (this.duplicatePropName) {
                errorLabel = this.$t("dataModel.modal.duplicatePropName", {
                    name: this.duplicatedPropNameLabel
                });
            }
            return errorLabel;
        }
    },
    watch: {
        propType: {
            handler(value) {
                if (value) {
                    if (this.propertyName && this.checkErrorState) {
                        this.modalBtnLabel.disabled = false;
                    } else {
                        this.modalBtnLabel.disabled = true;
                    }
                    if (!this.editAtr) {
                        this.checkIfExistsInPrimitives(value);
                        this.checkIfExistsInCatalogs(value);
                        this.checkIfIsEmb(value);
                        this.checkBlockChainDis(value);
                    }
                }
            },
            immediate: true
        },
        computedPropertyTypeFromEdit: {
            handler(value) {
                if (this.editAtr) {
                    this.checkIfExistsInPrimitives(value);
                    this.checkIfExistsInCatalogs(value);
                    this.checkIfIsEmb(value);
                    this.checkBlockChainDis(value);
                }
            },
            immediate: true
        },
        showAddEditPropertyData: {
            handler(value) {
                this.showModalFields = value;
            },
            immediate: true
        },
        draftMode: {
            handler(value) {
                if (!value) {
                    this.computedPropertyTypeFromEdit = this.draftValue;
                }
            }
        },
        propertyName() {
            this.propertyName = this.propertyName.charAt(0).toLowerCase() + this.propertyName.slice(1);
            const propName = this.propertyName;
            if (!propName) {
                this.modalBtnLabel.disabled = true;
            }
            if (propName) {
                this.checkDuplicatedProp(propName);
                this.checkSpecialCharacters(propName);
            }
        },
        computedPropertyNameFromEdit() {
            const vm = this;
            const propName = vm.propertyNameFromEdit;
            this.checkDuplicatedProp(propName);
            this.checkSpecialCharacters(propName);
        }
    },
    mounted() {
        this.actionsDlg.bind(this);
        this.modalBtnLabel.disabled = true;
        this.getCatList();
    },
    methods: {
        ...mapActions("catalogs", ["getCatList"]),
        ...mapMutations("main", ["setInterfaceDirty"]),
        existDataModelClass() {
            const list = [];
            this.optionsDataModel.forEach(
                currentClass => {
                    if (this.parentClassData && this.parentClassData.className && currentClass.value.toUpperCase()
                            !== this.parentClassData.className.toUpperCase()) {
                        list.push(currentClass);
                    } else if (this.parentClassData && !this.parentClassData.className) {
                        list.push(currentClass);
                    }
                }
            );
            return list;
        },
        optionsFilter(terms, obj) {
            let ignoreOption = false;
            if (
                obj.label !== "Base Types"
                && obj.label !== "Catalogs"
                && obj.label !== "Data Model"
            ) {
                ignoreOption = obj.label.toLowerCase().indexOf(terms) > -1;
            }
            return ignoreOption;
        },
        classListDdl() {
            this.optionsDataModel = [
                {
                    label: this.$t("dataModel.name").toUpperCase(),
                    value: "dtmodel",
                    itemDisabled: true,
                    className: "bg-grey-color f-pl-md"
                }
            ];
            this.optionsDataModel.push(
                ...this.classesListForModal.map(option => ({
                    label: option,
                    value: option,
                    className: "f-pl-lg list-items-popover"
                }))
            );
            return this.optionsDataModel;
        },
        checkIfExistsInPrimitives(val) {
            this.isIndexDis = true;
            if (val && val.length) {
                let valueOfVal = "";
                if (typeof val === "object") {
                    valueOfVal = val[0].value;
                } else {
                    valueOfVal = val;
                }
                if (
                    this.columnDataTypesWithAttDDL.findIndex(dataType => dataType.value === valueOfVal) !== -1
                ) {
                    if (valueOfVal === "Attachment" || valueOfVal === "RichText") {
                        this.computedIsIndexableFromEdit = false;
                        this.isIndexable = false;
                    } else {
                        this.computedIsIndexableFromEdit = !!this.computedIsIndexableFromEdit;
                        this.isIndexDis = false;
                    }
                    this.isListDis = false;
                    this.isList = false;
                } else {
                    this.isIndexable = false;
                    this.computedIsIndexableFromEdit = false;
                }
            }
        },
        checkIfExistsInCatalogs(val) {
            this.isCatDis = this.isCat;
            if (val && val.length) {
                let valueOfVal = "";
                if (typeof val === "object") {
                    valueOfVal = val[0].value;
                } else {
                    valueOfVal = val;
                }
                if (
                    this.existingCatalogsAsList.findIndex(dataType => dataType.label === valueOfVal) !== -1
                ) {
                    this.isListDis = false;
                    this.isIndexDis = true;
                    this.computedIsIndexableFromEdit = false;
                    this.isCatDis = true;
                } else if (
                    this.classesListForModal.findIndex(dataType => dataType === valueOfVal) !== -1
                ) {
                    this.isListDis = false;
                    this.isCatDis = false;
                } else {
                    if (this.classesListForModal.findIndex(dataType => dataType === valueOfVal) === -1) {
                        this.isListDis = true;
                        this.isCatDis = false;
                    }
                    this.computedIsListFromEdit = false;
                }
            } else {
                this.isListDis = true;
            }
        },
        checkBlockChainDis(val) {
            let found = false;
            let found1 = false;
            const existingClassList = [];

            for (let i = 0; i < this.parentClassArray.length; i++) {
                existingClassList.push(this.parentClassArray[i].name);
            }
            if (this.sendBlockChainToggle) {
                this.isBlockChnProp = true;
            } else if (
                this.temporaryClassInfo
                && !this.temporaryClassInfo.blockchain
                && this.classUuid === this.temporaryClassInfo.uuid
            ) {
                this.isBlockChnProp = false;
                this.blockLabel = false;
            } else if (
                existingClassList.findIndex(dataType => dataType === val) !== -1
            ) {
                this.parentClassArray.forEach(item => {
                    if (
                        this.parentClassData.pluginUuid === item.id
                            && !item.isBCReady
                            && !found1
                    ) {
                        this.isBlockChnProp = false;
                        found1 = true;
                    }
                });
                if (!found1) {
                    this.parentClassArray.forEach(item => {
                        if (val && item.name === val[0].value) {
                            this.isBlockChnProp = item.isBCReady;
                            if (!this.isBlockChnProp) {
                                if (this.editAtr) {
                                    this.computedBlockLabelFromEdit = false;
                                } else {
                                    this.blockLabel = false;
                                }
                            }
                        }
                    });
                }
            } else {
                this.parentClassArray.forEach(item => {
                    if (this.classUuid === item.id) {
                        this.isBlockChnProp = item.isBCReady;
                        found = true;
                    }
                });
                if (!found) {
                    this.isBlockChnProp = false;
                }
            }
        },
        checkIfIsEmb(val) {
            if (val && val.length) {
                const embeddedVal = typeof val === "object" ? val[0].value : val;
                if (
                    this.classesListForModal.findIndex(dataType => dataType === embeddedVal) !== -1
                ) {
                    this.isListDis = false;
                    if (this.editAtr) {
                        this.$emit("update:isEmbeddedFromEdit", true);
                    } else {
                        this.isEmbedded = true;
                    }
                } else if (this.editAtr) {
                    this.$emit("update:isEmbeddedFromEdit", false);
                } else {
                    this.isEmbedded = false;
                }
            }
        },
        checkDuplicatedProp(propName) {
            this.noNameFound = false;
            let checkDuplicatedPropNames = [];
            let found = false;
            const classId = this.classUuid;
            if (this.parentClassArray && this.parentClassArray.length > 0) {
                for (let i = 0; i < this.parentClassArray.length; i++) {
                    if (this.parentClassArray[i].id === classId) {
                        checkDuplicatedPropNames = this.parentClassArray[i].fields;
                        break;
                    } else {
                        checkDuplicatedPropNames = this.checkObjAttr;
                    }
                }
            } else {
                checkDuplicatedPropNames = this.checkObjAttr;
            }

            if (checkDuplicatedPropNames) {
                checkDuplicatedPropNames.forEach(el => {
                    const name = el.name || el.propertyName;
                    const { id } = el;
                    if (name === propName && id !== this.propertyUuid) {
                        this.duplicatePropName = true;
                        this.modalBtnLabel.disabled = true;
                        this.duplicatedPropNameLabel = propName;
                        found = true;
                    }
                });
            }

            if (!found) {
                this.duplicatePropName = false;
                if (this.propType && this.propType.length) {
                    this.modalBtnLabel.disabled = false;
                }
            }
        },
        checkSpecialCharacters(propName) {
            if (propName === "_index") {
                this.forbiddenAttrName = true;
            } else {
                const validatePattern = new RegExp(CHECK_NAME_REGEX_STARTING_ALPHA_ONLY);
                this.forbiddenAttrName = false;
                this.noNameFound = false;

                if (!validatePattern.test(
                    this.editAtr ? this.computedPropertyNameFromEdit : this.propertyName
                )) {
                    this.noNameFound = true;
                    this.isDisabled = true;
                }
            }
        },
        actionsDlg($event) {
            if ($event === "primary") {
                this.$emit("setNoAddingYet", false);
                if (this.editAtr) { // cazul de edit atribute
                    this.$emit("input", true);
                }
                let propTypeForm = "";
                if (this.editAtr) {
                    if (typeof this.propertyTypeFromEdit === "object") {
                        propTypeForm = this.propertyTypeFromEdit[0].value;
                    } else {
                        propTypeForm = this.propertyTypeFromEdit;
                    }
                } else {
                    propTypeForm = this.propType[0].value;
                }
                const fieldsToAdd = {
                    propertyName: this.editAtr
                        ? this.propertyNameFromEdit.charAt(0).toLowerCase()
                          + this.propertyNameFromEdit.slice(1)
                        : this.propertyName.charAt(0).toLowerCase()
                          + this.propertyName.slice(1),
                    propType: propTypeForm,
                    blockLabel: this.editAtr
                        ? this.blockLabelFromEdit
                        : this.blockLabel,
                    isEmbeded: this.editAtr
                        ? this.isEmbeddedFromEdit
                        : this.isEmbedded,
                    isIndexable: this.editAtr
                        ? this.isIndexableFromEdit
                        : this.isIndexable,
                    isList: this.editAtr ? this.isListFromEdit : this.isList,
                    isPersonalInformation: this.editAtr ? this.isPersonalInformationFromEdit : this.isPersonalInformation,
                    isCat: this.isCatDis,
                    classUuid: this.classUuid,
                    id: this.editAtr
                        ? this.propertyUuid
                        : shortId.uuid(),
                    className: this.parentClassData
                        ? this.parentClassData.className
                        : null
                };
                if (!fieldsToAdd.classUuid) {
                    const obj = {
                        index: this.indexAttr,
                        field: fieldsToAdd,
                        action: null
                    };
                    this.$root.$emit("actionAttribute", obj);
                } else {
                    this.$emit("setParentClassArray", {
                        ...this.temporaryClassInfo,
                        ...fieldsToAdd
                    });
                }
                this.showModalFields = false;
                this.$emit("input", true);
                if (this.createAnother) {
                    this.resetModalValues();
                    this.counter++;
                    this.counterName++;
                } else {
                    this.$emit("afterCloseModalAddProperty");
                }
                this.$store.commit("main/setInterfaceDirty", true);
            } else if ($event === this.$t("diagrams.components.setRules.delete")) {
                this.openDialog = true;
            } else if ($event === "close") {
                this.action = "close";
                if (this.hasChanges || !this.modalBtnLabel.disabled) {
                    this.openDialog = true;
                } else {
                    this.$emit("update:propertyNameFromEdit", "");
                    this.$emit("afterCloseModalAddProperty");
                }
            }
        },
        okAction() {
            if (this.action) { // close modal
                this.showModalFields = false;
                this.$emit("afterCloseModalAddProperty");
                this.$emit("input", false);
                this.action = null;
            } else if (!this.classUuid) { // delete attribute for new class
                const obj = {
                    index: this.indexAttr,
                    field: null,
                    action: "delete"
                };
                this.$root.$emit("actionAttribute", obj);
                this.$store.commit("main/setInterfaceDirty", true);
                this.$emit("afterCloseModalAddProperty");
            } else {
                const attrToDelete = {
                    classUuid: this.classUuid,
                    id: this.propertyUuid,
                    name: this.computedPropertyNameFromEdit
                };
                this.$emit("setParentClassArray", {
                    ...attrToDelete

                }, "delete");
                this.showModalFields = false;
                this.$store.commit("main/setInterfaceDirty", true);
                this.$emit("afterCloseModalAddProperty");
                this.$emit("input", false);
            }
        },

        closeModal() {
            this.showModalFields = false;
            this.$emit("afterCloseModalAddProperty");
        },
        resetModalValues() {
            this.propertyName = "";
            this.isIndexable = false;
            this.isList = false;
            if (typeof this.propType === "object") {
                this.propType = [];
            } else {
                this.propType = "";
            }
            this.showModalFields = true;
            this.blockLabel = false;
            this.isEmbedded = false;
            this.resetDefaultVal = true;
            setTimeout(() => {
                this.resetDefaultVal = false;
            }, 0);
        },
        changeStatus() {
            this.hasChanges = true;
            if ((this.computedPropertyNameFromEdit || this.propertyName) && (this.propType || this.computedPropertyTypeFromEdit) && !this.checkForErr()) {
                this.modalBtnLabel.disabled = false;
            }
        },
        checkForErr() {
            return this.forbiddenAttrName || this.noNameFound || this.duplicatePropName;
        },
        typeDDLOnChange() {
            this.draftMode = true;
            this.showDialog = true;
        },
        wrnAction(action) {
            if (action === "ok") {
                this.draftMode = false;
                this.hasChanges = true;
            } else {
                this.computedPropertyTypeFromEdit = this.initialValue;
                this.count++;
            }
            this.$emit("input", false);
        }
    }
};
